import React from 'react';
import { Link } from 'react-router-dom';
import './CallToAction.css'

const CallToAction = () => {
    return (
        <div>
            <div className='all-to-action-bg'>
            <div className="service-overly">
                <div className="py-5">
                    <div className='container text-white py-5'>
                        <div className="row g-md-4 ">
                            <div className='col-md-6'>
                                <h1 className='display-1 md:display-4'><span className='text-info'>Watch</span> world</h1>
                                <p className='fs-5'>Add Some Items or Restore Quantity</p>
                            </div>
                            <div className='col-md-6 d-flex justify-content-md-end align-items-center'>
                                <Link className="btn btn-info btn-lg" to='/addItem'>Add Items</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
};

export default CallToAction;